module.exports = __webpack_public_path__ + "img/f7ed2df.jpg";